import { Standard } from 'shared/types'

type StandardsState = {
  byId: { [id: string]: Standard }
  missing: string[]
  retrieving: string[]
}

export enum ActionType {
  Add,
  Retrieving,
}

type AddAction = {
  type: ActionType.Add
  standards: Standard[]
  missing: string[]
}

type RetrieveAction = {
  type: ActionType.Retrieving
  ids: string[]
}

type Action = AddAction | RetrieveAction

export const standardsReducer = (state: StandardsState, action: Action) => {
  switch (action.type) {
    case ActionType.Add: {
      const { standards, missing } = action
      const ids = standards.map(({ standardId }) => String(standardId))
      return {
        ...state,
        byId: {
          ...state.byId,
          ...standards.reduce<{ [id: string]: Standard }>((acc, standard) => {
            acc[standard.standardId] = standard
            return acc
          }, {}),
        },
        missing: [...state.missing, ...missing],
        retrieving: state.retrieving.filter((id) => !ids.includes(id)),
      }
    }
    case ActionType.Retrieving: {
      const { ids } = action
      return {
        ...state,
        retrieving: [...state.retrieving, ...ids],
      }
    }
    default:
      return state
  }
}
